import React from "react";
import { connect } from "react-redux";
import { History } from "history";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Input from "components/Input";
import CNBTextArea from "components/CNBTextArea";
import Button from "components/Button";
import Select from "components/Select";
import InputImage from "components/InputImage";
import CNBDatePicker from "components/CNBDatePicker";
import { ICultivationAdvice } from "models/.";
import BackgroundBlock from "../../deliveryNotes/partials/BackgroundBlock";
import { localRequest } from "../../../apiUtils";
import { STATUS_OPTIONS } from "../constants";
import CultivationAdviceActions from "../actions";

import "./style.scss";
import InputFile from "components/InputFile";

interface IProps {
  history: History;
  match: any;
  saveCultivationAdvice: (data) => void;
  getCultivationAdvice: (id) => void;
  currentItem: ICultivationAdvice;
  typeOptions: any[];
  getSelectOptions: () => void;
}

interface IState {
  data: any;
  showMenu: boolean;
  media: any[];
}

class NewCultivationAdvice extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      media: [],
      showMenu: false
    };
  }

  public componentDidMount() {
    const {
      match: { params },
      getCultivationAdvice,
      typeOptions,
      getSelectOptions
    } = this.props;

    if (params.id) {
      getCultivationAdvice(params.id);
    }

    if (!typeOptions || !typeOptions.length) {
      getSelectOptions();
    }
  }

  public async componentWillReceiveProps(nextProps) {
    const { currentItem } = nextProps;

    if (currentItem && !this.props.currentItem) {
      this.setState({
        data: _.omit(currentItem, ["Media", "Pdf", "Photo", "Content"]),
        media: JSON.parse(_.get(currentItem, "Content", "{}"))
      });

      if (currentItem.Photo) {
        const Photo = await this.getUploadedFile(currentItem.Photo);
        this.setState(({ data }) => ({ data: { ...data, Photo } }));
      }

      if (currentItem.Pdf && currentItem.Pdf !== "undefined") {
        const Pdf = await this.getUploadedFile(currentItem.Pdf);
        this.setState(({ data }) => ({ data: { ...data, Pdf } }));
      }
    }
  }

  private handleFieldChange(name, value) {
    this.setState({ data: { ...this.state.data, [name]: value } });
  }

  private handleRemovePdf = () => {
    this.setState(({ data }) => ({ data: { ...data, Pdf: undefined } }));
  };

  private handleSubmit = e => {
    e.preventDefault();
    const formData = new FormData();
    const { data: fields, media } = this.state;

    const { Pdf, Photo, ...data } = fields;

    const photoId = _.get(Photo, "_id", "");
    const pdfId = _.get(Pdf, "_id", "");

    formData.append("Photo", photoId ? photoId : Photo || "");
    formData.append("Pdf", pdfId ? pdfId : Pdf);

    _.forEach(data, (value, key) => formData.append(key, value));
    _.forEach(media, value => {
      const isNewPhoto = value.photo && _.isObject(value.photo);
      isNewPhoto && formData.append("Media", value.photo);
    });

    const content = _.map(
      media,
      value =>
        value.photo && _.isObject(value.photo)
          ? _.set(value, "photo", value.photo.name)
          : value
    );
    formData.append("Content", JSON.stringify(content));

    this.props.saveCultivationAdvice(formData);
  };

  private async getUploadedFile(id) {
    const url = `files/full/${id}`;
    const { data: fileInfo } = await localRequest({ method: "get", url });
    const { _id, name, data: buffer, contentType } = fileInfo;

    const file = new File([Buffer.from(buffer.data)], name, {
      type: contentType
    }) as any;
    file._id = _id;

    return file;
  }

  public render() {
    const {
      Date: dateValue,
      Status,
      Photo,
      Pdf,
      Type,
      Title_nl = "",
      Title_en,
      Teaser_nl = "",
      Teaser_en
    } = this.state.data;
    const { history, typeOptions } = this.props;

    const disabled = !(Title_nl && Status && Type && Teaser_nl);

    return (
      <form id="new-cultivation-advice" onSubmit={this.handleSubmit}>
        <FormattedMessage id="CULTIVATION_ADVICES" tagName="h1" />
        <BackgroundBlock className="advice-form">
          <div className="datum">
            <FormattedMessage id="DATE" tagName="label" />
            <CNBDatePicker
              startDate={dateValue || new Date()}
              onChange={value => this.handleFieldChange("Date", value)}
            />
          </div>
          <Input
            value={Title_nl}
            label="TITLE_NL"
            placeholder="TITLE_NL"
            onChange={e => this.handleFieldChange("Title_nl", e.target.value)}
          />
          <Input
            value={Title_en}
            label="TITLE_EN"
            placeholder="TITLE_EN"
            onChange={e => this.handleFieldChange("Title_en", e.target.value)}
          />
          <Select
            options={STATUS_OPTIONS}
            selectedOption={Status}
            onChange={option =>
              this.handleFieldChange("Status", option && option.value)
            }
            placeholder="PUBLISHED"
            label="STATUS"
          />
          <Select
            options={typeOptions}
            selectedOption={Type}
            onChange={option =>
              this.handleFieldChange("Type", option && option.value)
            }
            placeholder="TULIP"
            label="TYPE"
          />
          <InputImage
            label="CULTIVATION_ADVICES_IMG"
            file={Photo}
            onChange={file => this.handleFieldChange("Photo", file)}
          />
          <InputFile
            label="CULTIVATION_ADVICES_PDF"
            files={Pdf && [Pdf]}
            name="media"
            extensions={["pdf"]}
            onChange={([file]) => this.handleFieldChange("Pdf", file)}
            remove={this.handleRemovePdf}
          />
          <CNBTextArea
            rows={6}
            value={Teaser_nl}
            label="TEXT_TEASER_NL"
            onChange={e => this.handleFieldChange("Teaser_nl", e.target.value)}
          />
          <CNBTextArea
            rows={6}
            value={Teaser_en}
            label="TEXT_TEASER_EN"
            onChange={e => this.handleFieldChange("Teaser_en", e.target.value)}
          />
        </BackgroundBlock>
        <div className="submit-btn">
          <Button kind="gray" onClick={() => history.back()} type="button">
            CANCEL
          </Button>
          <Button kind="primary" disabled={disabled}>
            SAVE
          </Button>
        </div>
      </form>
    );
  }
}

export default connect(
  state => ({
    currentItem: state.cultivationAdvices.currentItem,
    typeOptions: state.cultivationAdvices.typeOptions
  }),
  {
    getCultivationAdvice: CultivationAdviceActions.getCultivationAdvice,
    saveCultivationAdvice: CultivationAdviceActions.saveCultivationAdvice,
    getSelectOptions: CultivationAdviceActions.getSelectOptions
  }
)(NewCultivationAdvice);
